import { find, isNaN, isNil, omit, reduce, uniqueId } from 'lodash/fp'
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'

const MANUFACTURER_ID_PREFIX = 'manufacturer_'

export default {
  data () {
    return {
      manufacturers: [],
      manufacturersExpand: null
    }
  },
  computed: {
    manufacturersListErrors () {
      const errors = []
      return errors
    },
    manufacturersErrors () {
      console.log('computing manufacturersErrors')
      console.log('this.$v.manufacturers', this.$v.manufacturers)
      let errors = {}

      if (!this.hasManyManufacturers) return errors

      console.log('this.$v.manufacturers.$each', this.$v.manufacturers.$each)

      for (let index in this.$v.manufacturers.$each) {
        if (isNaN(parseInt(index, 10))) continue

        console.log('index: ', index)
        console.log('this.$v.manufacturers.$each[index]: ', this.$v.manufacturers.$each[index])
        errors[index] = {
          manufacturerName: [],
          partNumber: [],
          computerEaseNumber: []
        }
        if (!this.$v.manufacturers.$each[index].$anyDirty) continue
        // Manufacturer
        if (
          this.$v.manufacturers.$each[index].manufacturerName.$dirty &&
          !this.$v.manufacturers.$each[index].manufacturerName.required
        ) errors[index].manufacturerName = 'Manufacturer is required'
        if (!this.$v.manufacturers.$each[index].manufacturerName.uniqueManufacturer) errors[index].manufacturerName = 'Manufacturers should only be listed once'

        // Part Number
        if (
          this.$v.manufacturers.$each[index].partNumber.$dirty &&
          !this.$v.manufacturers.$each[index].partNumber.required
        ) {
          errors[index].partNumber = 'Manufacturer Part No. is required'
        }

        // CE Number
        if (
          this.$v.manufacturers.$each[index].computerEaseNumber.$dirty &&
          !this.$v.manufacturers.$each[index].computerEaseNumber.isUnique
        ) {
          errors[index].computerEaseNumber = 'This CE # already exists'
        }
      }

      console.log('RETURNING COMPUTED ERRORS: ', errors)

      return errors
    },
    manufacturersMap () {
      return reduce((result, value) => {
        if (value.manufacturer.id) result[value.manufacturer.id] = omit('key')(value)
        return result
      })({})(this.manufacturers)
    },

    ...mapGetters({
      manufacturerNames: 'manufacturers/manufacturerNames',
      existingManufacturers: 'manufacturers/manufacturers',
      getManufacturer: 'manufacturers/manufacturer',
      getItemByComputerEaseNumber: 'standardItems/items/getItemByComputerEaseNumber'
    })
  },

  methods: {
    manufacturerValidations () {
      return {
        manufacturers: {
          $each: {
            manufacturerName: {
              required,
              uniqueManufacturer: this.uniqueManufacturer
            },
            partNumber: { required },
            computerEaseNumber: {
              isUnique (value, parentVm) {
                console.log('CE # validationFunction: ')
                console.log('value: ', value)
                console.log('parentVm: ', parentVm)
                console.log('this: ', this)
                console.log('standardItem', this.standardItem)
                console.log('this.id', this.id)
                // Ignore empty values
                if (value === '' || isNil(value)) return true
                if (!value.length) return true

                // If this is an edit
                // check if the current manufacturer value exists on the item and has a matching CE #
                if (this.edit) {
                  const oldValue = find(manufacturer => {
                    return manufacturer.manufacturerName === parentVm.manufacturerName
                  })(this.standardItem.manufacturers)

                  console.log('oldValue', oldValue)
                  if (oldValue && value === oldValue.computerEaseNumber) return true
                } else {
                  // For New Items, we need to check the other CE Values trying to be saved
                  const localMatch = this.manufacturers.findIndex(m => {
                    return m.key !== parentVm.key && m.computerEaseNumber === value
                  })
                  if (localMatch >= 0) return false
                }

                return new Promise((resolve, reject) => {
                  // Get an array of all items that have this CE#
                  let matchingItems = this.getItemByComputerEaseNumber(value)
                  console.log('matchingItems: ', matchingItems)
                  // If there aren't any matches, we're good
                  if (!matchingItems) resolve(true)

                  // If there is a match, but its exactly 1 with the same id
                  // then we need to check if its the same manufacturer
                  if (matchingItems.length === 1 && matchingItems[0].id === this.id) {
                    const matchedItem = matchingItems[0]
                    console.log('matchedItem', matchedItem)
                    const matchedManufacturer = find(manufacturer => {
                      return manufacturer.manufacturerName === parentVm.manufacturerName
                    })(matchedItem.manufacturers)
                    console.log('matchedManufacturer', matchedManufacturer)
                    const result = matchedManufacturer
                      ? value === matchedManufacturer.computerEaseNumber
                      : false
                    resolve(result)
                  }

                  resolve(!matchingItems.length)
                })
              }
            }
          }
        }
      }
    },

    uniqueManufacturer (value, parentVm) {
      if (value) {
        const manufacturers = this.manufacturers.filter(manufacturer => manufacturer.manufacturerName === value)
        if (manufacturers && manufacturers.length && manufacturers.length > 1) {
          return false
        }

        return true
      }
      return true
    },

    addManufacturer () {
      const newKey = uniqueId(MANUFACTURER_ID_PREFIX)
      this.manufacturers.push({
        manufacturerName: null,
        partNumber: null,
        computerEaseNumber: null,
        key: newKey
      })

      this.$nextTick(function () {
        console.log('this: ', this)
        let newInput = this.$refs[`${newKey}__name-input`][0]
        console.log('newInput: ', newInput)
        newInput.$refs.input && newInput.$refs.input.select()
      })
    },

    async saveManufacturers () {
      console.log('save manufacturers')
      // Add manufacturers
      const existingManufacturers = this.existingManufacturers
      let manufacturersToSave = await this.manufacturers.reduce(async (previousPromise, curr) => {
        let collection = await previousPromise

        if (curr && !curr.manufacturerName.trim().length) return collection

        let manufacturer = existingManufacturers.find(m => m.name === curr.manufacturerName.trim())
        let manufacturerID
        if (!manufacturer) {
          manufacturerID = await this.saveManufacturer({ name: curr.manufacturerName })
          manufacturer = this.getManufacturer(manufacturerID)
        } else {
          manufacturerID = manufacturer.id
        }

        collection[manufacturerID] = {
          ...omit('key')(curr),
          manufacturer
        }
        return collection
      }, Promise.resolve({}))

      console.log('manufacturers TO SAVE: ', manufacturersToSave)
      return { manufacturers: manufacturersToSave }
    },

    fillManufacturers (standardItem) {
      this.manufacturers = standardItem && standardItem.manufacturers
        ? Object.values(standardItem.manufacturers).map(manufacturer => {
          return {
            manufacturerName: manufacturer.manufacturer.name,
            partNumber: manufacturer.partNumber,
            key: uniqueId(MANUFACTURER_ID_PREFIX),
            computerEaseNumber: manufacturer.computerEaseNumber
          }
        })
        : []
      console.log('this.manufacturers', this.manufacturers)
    },

    manufacturersInput ({ event, field, index, key }) {
      this.delayTouch(this.$v.manufacturers.$each[index][field])
    },

    ...mapActions({
      saveManufacturer: 'manufacturers/add',
      getManufacturers: 'manufacturers/get'
    })
  },
  created () {
    this.getManufacturers()
  }
}
